import { useState } from "react";
import { Download, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const DataRights = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [d, setD] = useState({ password: "", keep_published: true });
  const [busy, setBusy] = useState(false);
  if (user.role === "admin") return null;

  const download = async () => {
    try {
      const r = await api.get("/me/export", { responseType: "blob" });
      const a = Object.assign(document.createElement("a"), { href: URL.createObjectURL(r.data), download: "my-lorekeepers-data.json" });
      a.click(); URL.revokeObjectURL(a.href);
    } catch (e) { toast.error(errMsg(e)); }
  };
  const remove = async (e) => {
    e.preventDefault();
    if (!window.confirm("Permanently delete your account? This cannot be undone.")) return;
    setBusy(true);
    try { await api.post("/me/delete", d); toast.success("Your account has been deleted"); await logout(); navigate("/"); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <section data-testid="data-rights" className="grid gap-3 pt-5 mt-2 border-t border-[#c9a227]/40">
      <p className="eyebrow">Your data</p>
      <button type="button" data-testid="data-download" onClick={download} className="btn-ghost-illum justify-self-start"><Download className="w-4 h-4" /> Download my data</button>
      {user.is_master ? <p className="text-xs italic text-[#5e4a35]">The master reader account can't be deleted.</p> : !open
        ? <button type="button" data-testid="data-delete-open" onClick={() => setOpen(true)} className="text-sm font-heading text-[#991b1b] underline justify-self-start">Delete my account…</button>
        : (
          <form onSubmit={remove} data-testid="data-delete-form" className="grid gap-3 p-4 border border-[#991b1b]/60 bg-[#991b1b]/[0.05]">
            <p className="text-sm font-heading font-bold text-[#991b1b]">Delete account permanently</p>
            <p className="text-sm">What should happen to your <b>published</b> articles? Drafts and unpublished submissions are always deleted.</p>
            <label className="flex items-center gap-2 text-sm"><input type="radio" data-testid="data-delete-keep" checked={d.keep_published} onChange={() => setD({ ...d, keep_published: true })} /> Keep them published, credited to "A former reader"</label>
            <label className="flex items-center gap-2 text-sm"><input type="radio" data-testid="data-delete-all" checked={!d.keep_published} onChange={() => setD({ ...d, keep_published: false })} /> Delete them too</label>
            <label><span className="admin-label">Confirm with your password</span><input type="password" data-testid="data-delete-password" required className="admin-input" value={d.password} onChange={(e) => setD({ ...d, password: e.target.value })} /></label>
            <div className="flex gap-3">
              <button data-testid="data-delete-confirm" disabled={busy} className="btn-illum !bg-[#991b1b] disabled:opacity-60"><Trash2 className="w-4 h-4" /> {busy ? "Deleting…" : "Delete my account"}</button>
              <button type="button" onClick={() => setOpen(false)} className="btn-ghost-illum">Cancel</button>
            </div>
          </form>
        )}
    </section>
  );
};
